var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.loading,"z-index":"9999"}},[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}}),_c('div',{staticClass:"mt-4"},[_c('h3',{staticClass:"white--text"},[_vm._v(" Yükleniyor... ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }